import { render, staticRenderFns } from "./FixedRentalExpired.vue?vue&type=template&id=f25245b0"
import script from "./FixedRentalExpired.vue?vue&type=script&lang=js"
export * from "./FixedRentalExpired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports